export const currencyUtils = {
    formatCurrency: amount => {
        if (Number.isInteger(amount)) {
            return `$${amount.toFixed(2)}`;
        } else {
            return `$${amount.toFixed(2)}`;
        }
    }
}
